import { State } from '@meraki-internal/state';
import { OrganizationsState } from '../organizations/OrganizationsState';

/**
 * Agency staff know every person by their photo, else their initials, never an illustration or a
 * bare colour: across a whole caseload many people share the same illustration (the bee is everyone's
 * default), so it cannot tell them apart. It follows who is looking, so it changes when their
 * organizations do.
 */
export class AgencyAvatarLook extends State<{ identifiesByPhotoOrInitials: boolean }> {
    static inject = () => [OrganizationsState];
    constructor(private organizations: OrganizationsState) {
        super({ identifiesByPhotoOrInitials: organizations.isOrgTeamMember() });
        organizations.subscribe(this.follow);
    }

    identifiesByPhotoOrInitials = (): boolean => this.state.identifiesByPhotoOrInitials;

    // OrganizationsState publishes on every roster refresh, which rarely changes this.
    private follow = () => {
        const identifiesByPhotoOrInitials = this.organizations.isOrgTeamMember();
        if (identifiesByPhotoOrInitials !== this.state.identifiesByPhotoOrInitials) {
            this.setState({ identifiesByPhotoOrInitials });
        }
    };
}
